import signIn from '../services/signIn';
import { changeSignInState } from '../actions/presenceActions';
import ChatSignInState from '../store/schema/ChatSignInState';
import InstantMessageOperationError from '../store/schema/InstantMessageOperationError';

export default function signInIM(signedInManually: boolean) {
    signIn(false /*signedInManually*/).then(result => {
        onSignIn(result);
    });
}

function onSignIn(result: number) {
    if (result == InstantMessageOperationError.Success) {
        changeSignInState(ChatSignInState.SignedIn);
    }
}
